// extracted by mini-css-extract-plugin
export var chevron = "_mw-2";
export var chevronRotated = "_mw-3";
export var header = "_mw-1";
export var section = "_mw-0";